import api from '@/API';
import { UserClient, User } from '@/type';
import eventBus from '@/messaging/event-bus';
import { ClientAssignedToUser, ClientUnassignedFromUser } from '@/messaging/events';

export function assignAll(clientId: number, userIds: number[]): Promise<User[]> {
  return api
    .post(`clients/${clientId}/users`, { userIds })
    .then((response) => {
      const clientUsers = (response.data as User[]);
      clientUsers.forEach((cu) => {
        eventBus.$emit(
          ClientAssignedToUser.eventName,
          new ClientAssignedToUser(cu),
        );
      });
      return clientUsers;
    });
}

export function unassign(clientUser: UserClient): Promise<void> {
  return api
    .delete(`/user-clients/${clientUser.id}`)
    .then(() => {
      eventBus.$emit(
        ClientUnassignedFromUser.eventName,
        new ClientUnassignedFromUser(clientUser),
      );
    });
}

export function unassignAll(clientUsers: UserClient[]): Promise<void[]> {
  const tasks: Promise<void>[] = [];
  clientUsers.forEach((cu) => {
    tasks.push(unassign(cu));
  });
  return Promise.all(tasks);
}
